<template>
	<TemplateSales v-bind="props">
		<slot />
		{{ backgroundImage }}
	</TemplateSales>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { ImageType } from '#base/core/types/ImageType';

const props = defineProps<{
	backgroundImage?: ImageType;
	breadcrumbs?: BreadcrumbsType;
}>();
</script>
